import React, { useState } from 'react';
import MediaQuery from 'react-responsive/src/Component';
import { useViewport } from 'components/templates/viewportProvider';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import JoinOurTeam from 'components/organisms/joinOurTeam';
import './styles.scss';

const JoinOurTeamAbout = props => {
  const { height } = useViewport();
  const [sliderRef, setSlider] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const jobs = props.data.jobPosts;
  const { toggleId } = props.data;

  const handleSliderRef = ref => {
    setSlider(ref);
  };

  return (
    <div id={toggleId ? 'careers' : 'open-positions'}>
      <MediaQuery maxDeviceWidth={575.6}>
        <div className={'join-our-team-mobile'} style={{ height }}>
          <div className={'inner-section'}>
            <h1 className={'section-heading'}>Join the Team</h1>
            <HorizontalCarousel
              data={jobs}
              type={'join-our-team-mobile'}
              getActiveSlide={e => {
                setActiveSlide(e);
              }}
              handleSliderRef={handleSliderRef}
            />
          </div>
        </div>
      </MediaQuery>
      <MediaQuery minDeviceWidth={576}>
        <JoinOurTeam data={props} />
      </MediaQuery>
    </div>
  );
};

export default JoinOurTeamAbout;
